// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"524":"a635fe0b514712ae95f6","838":"cf9bc4177f51410cbc68"}[chunkId] + ".css";
};